import * as Sentry from '@sentry/react';
import { apis } from 'utils/lib/apis';

function extractLogId(raw) {
    if (!raw || typeof raw !== 'object') return null;
    if (raw.success === true && raw.data && typeof raw.data === 'object') {
        return extractLogId(raw.data);
    }
    const candidate = raw.log_id ?? raw.logId ?? null;
    if (candidate == null || candidate === '') return null;
    const s = String(candidate).trim();
    return s.length ? s : null;
}

export async function syncAssignmentActivityMeta(submissionId, metaData) {
    if (!submissionId || metaData == null) return null;
    try {
        const raw = await apis.put('assignmentsRDS', `/assignments/${submissionId}/activityLog`, {
            body: { meta_data: metaData },
        });
        return extractLogId(raw);
    } catch (error) {
        Sentry.captureException(error);
        return null;
    }
}
